'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateCompleteApplication = exports.checkGuardian = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _translate = require('../../language/translate');

var _step2Functions = require('../../helpers/step2Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Checks whether, given a list of applicants, a legal guardian is not required
 * @param array applicants - The applicants to be checked
 * @return bool Whether a guardian is not reuqired
 */
var checkGuardian = exports.checkGuardian = function checkGuardian(applicants) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = applicants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var applicant = _step.value;

      if ((0, _moment2.default)(applicant.dob.value).isBefore((0, _moment2.default)().subtract({
        years: 18 }))) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
};

var validateCompleteApplication = exports.validateCompleteApplication = function validateCompleteApplication(values, props) {
  var gaurdianCheck = checkGuardian(props.form.applicant);
  return _extends({
    application: {
      additional_data: {
        province_of_residence: !values.applicant[0].state && (0, _translate.t)('Province/State is required')
      }
    },
    applicant: values.applicant.map(function (applicant, i) {
      var x = i + 1;
      return {
        sex: !applicant.sex && (0, _translate.t)('Applicant %(index)d: Gender is Required', { index: x }),
        address_line_1: i === 0 && !applicant.address_line_1 && (0, _translate.t)('Address Line 1 is Required'),
        city: i === 0 && !applicant.city && (0, _translate.t)('City is Required'),
        postal_code: i === 0 && !applicant.postal_code && (0, _translate.t)('Postal Code is Required'),
        phone: i === 0 && !applicant.phone && (0, _translate.t)('Phone Number is Required'),
        additional_data: {
          legal_guardian: i === 0 && !applicant.additional_data.legal_guardian && !gaurdianCheck && (0, _translate.t)('Name of Legal Guardian/Custodian is required'),
          beneficiary: {
            name: i === 0 && !applicant.additional_data.beneficiary.name && (0, _translate.t)('Beneficiary Name is required'),
            address: i === 0 && !applicant.additional_data.beneficiary.address && (0, _translate.t)('Beneficiary Address is required'),
            city: i === 0 && !applicant.additional_data.beneficiary.city && (0, _translate.t)('Beneficiary City is required'),
            country_code: i === 0 && !applicant.additional_data.beneficiary.country_code && (0, _translate.t)('Beneficiary Country is required'),
            relationship_to_insured: i === 0 && !applicant.additional_data.beneficiary.relationship_to_insured && (0, _translate.t)('Beneficiary Relationship to Insured is required')
          }
        }
      };
    })
  }, (0, _step2Functions.validatePayment)(values));
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/international-students/Applicants.js
// module id = 825
// module chunks = 0